<ziro-phone [isPublicPhone]="true" (save$)="onSave($event)" (delete$)="goHome()" (cancel$)="goHome()"></ziro-phone>
